import React, { Component } from 'react';
import styled from 'styled-components';

const StyledLabel = styled.label`
  font-weight: 700;
  margin-bottom: 10px;
  display: block;
  color: ${props => props.error ? "red" : "black"};
`

const Required = styled.label`
  color: red;
`

class Label extends Component {
  render() {
    return (
      <StyledLabel htmlFor={this.props.name} error={this.props.error} style={this.props.style}>
        {this.props.value}
        {this.props.required && (<Required>*</Required>)}
      </StyledLabel>
    )
  }
}

export default Label